import { render, staticRenderFns } from "./OtherCompanion.vue?vue&type=template&id=3123695b"
import script from "./OtherCompanion.vue?vue&type=script&lang=js"
export * from "./OtherCompanion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports